import React from 'react';
// Api
import { GetCampaignsV2_getCampaigns_entities_activities_SocialBoostActivity } from 'api/campaignV2/types/GetCampaignsV2';
// Styles
import styles from '../CampaignActivityData.module.scss';

type SocialBoostActivityProps = {
  socialBoostActivity: GetCampaignsV2_getCampaigns_entities_activities_SocialBoostActivity;
};

const SocialBoostActivity = ({
  socialBoostActivity,
}: SocialBoostActivityProps): JSX.Element | null => {
  if (!socialBoostActivity) {
    return null;
  }

  const {
    brandName,
    website,
    postUrl,
    caption,
    tags,
    linkStickerUrl,
    linkStickerTitle,
  } = socialBoostActivity;

  return (
    <>
      {brandName && (
        <div>
          <p className={styles.label}>Brand Name</p>
          <p className={styles.value}>{brandName}</p>
        </div>
      )}

      {website && (
        <div>
          <p className={styles.label}>Website</p>
          <p className={styles.value}>{website}</p>
        </div>
      )}

      {postUrl && (
        <div>
          <p className={styles.label}>Post URL</p>
          <p className={styles.value}>
            <a href={postUrl} target="_blank" rel="noopener noreferrer">
              {postUrl}
            </a>
          </p>
        </div>
      )}

      {caption && (
        <div>
          <p className={styles.label}>Caption</p>
          <p className={styles.value}>{caption}</p>
        </div>
      )}

      <div>
        <p className={styles.label}>Tags</p>
        <p className={styles.value}>{tags?.length ? tags.join(', ') : 'n/a'}</p>
      </div>

      {linkStickerUrl && (
        <div>
          <p className={styles.label}>Link Sticker URL</p>
          <p className={styles.value}>{linkStickerUrl}</p>
        </div>
      )}

      {linkStickerTitle && (
        <div>
          <p className={styles.label}>Link Sticker Title</p>
          <p className={styles.value}>{linkStickerTitle}</p>
        </div>
      )}
    </>
  );
};

export default SocialBoostActivity;
